import { render } from "./ServiceOrderShow.vue?vue&type=template&id=590bb0e6&scoped=true"
import script from "./ServiceOrderShow.vue?vue&type=script&lang=js"
export * from "./ServiceOrderShow.vue?vue&type=script&lang=js"

import "./ServiceOrderShow.vue?vue&type=style&index=0&id=590bb0e6&scoped=true&lang=css"

import exportComponent from "C:\\docker\\bene_piscinas_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-590bb0e6"]])

export default __exports__